export default class UI_BoosterLabel extends Phaser.Group {
  /**
   * The text label that appears when you click on a booster and it teaches you how to use it
   * in brief words
   * @param {Game} state
   */
  constructor(state) {
    super(game);

    this._state = state;

    this._ico = G.makeImage(0, 0, null, 0.5, this); // Booster preview image

    this._txt = new G.Text(0, 0, '', { // Booster test
      style: 'font-white',
      fontSize: '30px',
      lineSpacing: '-5px',
    }, 0, false, false, true, 'center');
    this.add(this._txt);

    /* eslint-disable quote-props */
    this.textLookup = {
      '1': OMT.language.getText('Use the swap booster to change the place of two cookies!'),
      '2': OMT.language.getText('Use the star wand to crush one cookie!'),
      '3': OMT.language.getText('Use the horizontal pin to clear the whole row!'),
      '4': OMT.language.getText('Use the vertical pin to clear the whole column!'),
    };
    /* eslint-enable quote-props */

    this._signalBindings = [];
    this._signalBindings.push(G.sb('onScreenResize').add(this._resize, this));

    this.pivotYSettings = null; // Accessed externally

    this._signalBindings.push(G.sb('onBoosterSelect').add(this._init, this));
    this._signalBindings.push(G.sb('closeOverlay').add(this._hide, this));
  }

  /**
   * Destroy!
   */
  destroy() {
    if (this._signalBindings) {
      this._signalBindings.forEach((binding) => {
        if (binding.detach) {
          binding.detach();
        }
      });
      this._signalBindings = null;
    }
    super.destroy();
  }

  /**
   * Inits the label when it shows up
   * @param {Object} boosterData
   * @param {number} boosterData.boosterNr
   */
  _init(boosterData) {
    if (G.tutorialOpened) return;

    const { boosterNr } = boosterData;
    G.changeTexture(this._ico, G.OMTsettings.global.jungleMatch 
      ? `ui_booster_${boosterNr}_no_bg` : `ui_booster_${boosterNr}` );
    this._txt.setText(this.textLookup[boosterNr.toString()]);

    this._refreshPivot();

    this.alpha = 0;
    G.stopTweens(this);
    game.add.tween(this)
      .to({ alpha: 1 }, 500, Phaser.Easing.Sinusoidal.Out, true);
    this._resize();
  }

  _hide() {
    G.stopTweens(this);
    game.add.tween(this)
      .to({ alpha: 0 }, 500, Phaser.Easing.Sinusoidal.Out, true);
  }

  /**
   * Fixes pivot
   */
  _refreshPivot() {
    if (this.pivotYSettings !== null) {
      this.pivot.y = this.pivotYSettings;
      this.pivotYSettings = null;
    }
  }

  /**
   * Resize
   */
  _resize() {
    /**
     * Horizontal feedback for booster labels seemed like it was a half done job sort of thing
     * Plus it is not certain that there is even enough horizontal space for the text to be in at a certain resolution
     * Maybe in the future we can use the horizontal space but for now, what works well should be used.
    */
    // if (G.horizontal) {
    //   this.x = G.l(330);
    //   this._txt.wordWrapWidth = G.l(400);
    //   this._refreshHorizontal();
    // } else {
    this.x = G.l(330);
    this._txt.wordWrapWidth = G.l(400);
    this._refreshVertical();
    // }
    this.y = this._state.board.y - G.l(140);
  }

  /**
   * Repositions if in horizontal mode
   */
  _refreshHorizontal() {
    const startY = (this._ico.height + this._txt.height + G.l(10)) * -0.5;
    this._ico.y = startY;
    this._ico.x = 0;
    this._txt.y = this._ico.y + this._ico.height + G.l(10);
    this._txt.x = 0;
    this._txt.anchor.setTo(0.5, 0);
  }

  /**
   * Repositions if in vertical mode
   */
  _refreshVertical() {
    const startX = (this._ico.width + this._txt.width + G.l(10)) * -0.5;
    this._ico.y = 0;
    this._ico.x = startX;
    this._txt.x = this._ico.x + this._ico.width + G.l(10);
    this._txt.y = 0;
    this._txt.anchor.setTo(0, 0.5);
  }
}
